import React from 'react';
import MainInfoTracLayout from '../../../../components/Layout/Main';
import Content from '../../../../components/Pages/InsertManagement/Edit/Step1';

function InsertManagementEditStep1() {
  return (
    <MainInfoTracLayout className="min-h-[100vh] bg-white" isOldPage>
      <Content />
    </MainInfoTracLayout>
  );
}

export default InsertManagementEditStep1;
